import React from 'react';

const tuckOptions = [
  { label: 'Fully Tucked', value: 'full' },
  { label: 'Half Tucked', value: 'half' },
  { label: 'Untucked', value: 'untucked' }
];

const StepTuckPreference = ({ data, setData, onNext, onPrev }) => {
  const handleSelect = (value) => {
    setData(prev => ({
      ...prev,
      tuckPreference: value
    }));
  };

  const handleSkip = () => {
    setData(prev => ({
      ...prev,
      tuckPreference: null
    }));
    onNext();
  };

  return (
    <main className="rbt-main-wrapper">
      <div className="container custom-checkout-container">
        <div className="row">
          <div className="">
            <div className="tuck-shirt-container">
              <h3 className="tuck-shirt-title">How do you prefer to tuck your shirt?</h3>

              {tuckOptions.map(option => (
                <button
                  key={option.value}
                  className={`tuck-shirt-btn ${data.tuckPreference === option.value ? 'active' : ''}`}
                  onClick={() => handleSelect(option.value)}
                >
                  {option.label}
                </button>
              ))}

              <button className="tuck-shirt-skip mt-3" onClick={handleSkip}>
                I'm not sure, skip this question
              </button>

              <div className="tuck-shirt-nav mt-4">
                <button className="tuck-shirt-prev-btn" onClick={onPrev}>Prev</button>
                <button
                  className="tuck-shirt-next-btn"
                  onClick={onNext}
                  disabled={!data.tuckPreference}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default StepTuckPreference;
